import { StockExposure } from 'actions';

const initialState = {
  isFetching: false,
  accounts: [],
  search: [],
  tickers: [],
  prevSearch: null,
  percentToggled: true,
  preSelectedAccounts: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case StockExposure.STOCKEXPOSURE_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case StockExposure.STOCKEXPOSURE_FETCH_REQUEST:
      return {
        ...state,
        isFetching: true,
        accounts: action.accounts,
        tickers: action.stock_tickers,
      };
    case StockExposure.STOCKEXPOSURE_FETCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.data,
      };
    case StockExposure.STOCKEXPOSURE_SEARCH_SUCCESS:
      return {
        ...state,
        isFetching: false,
        search: action.data,
      };
    case StockExposure.STOCKEXPOSURE_PREV_SEARCH:
      return {
        ...state,
        prevSearch: action.ticker,
      };
    case StockExposure.STOCKEXPOSURE_UPDATE_TOGGLE:
      return {
        ...state,
        percentToggled: action.toggle,
      };
    case StockExposure.STOCKEXPOSURE_SET_SELECTED_ACCOUNTS:
      return {
        ...state,
        preSelectedAccounts: action.accounts,
      };
    case StockExposure.STOCKEXPOSURE_CLEAR:
      return initialState;
    case StockExposure.STOCKEXPOSURE_FAIL:
      return initialState;
    default:
      return state;
  }
}
